import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveEmployeeEntity } from 'API';
import { selectAgaveSlice } from 'app/pages/store/agaveSlice';
import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { supportsCodeSort } from 'util/codingSortSetting';

interface AgaveEmployeesDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedEmployee?: AgaveEmployeeEntity | null;
  onValueChange: (option: AgaveEmployeeEntity | null) => void;
  placeholder?: string;
  enabled?: boolean;
  locationId?: string;
  /** Load options only when dropdown opens (use in table rows to avoid stale shared state). */
  fetchOnlyOnOpen?: boolean;
}

const AgaveEmployeesDropdown = ({
  disabled,
  disableHeader = true,
  selectedEmployee,
  onValueChange,
  placeholder,
  enabled = true,
  locationId,
  fetchOnlyOnOpen,
}: AgaveEmployeesDropdownProps) => {
  // SEE-1622: label employees with their ERP employee id (Intacct EMPLOYEEID,
  // e.g. EMP00025) wherever code sorting is supported — the same gate and the
  // same reason as vendors: without it the label repeats the name
  // ("Abraham; Greg - (Abraham; Greg)") and code order reads as random. QB
  // employee ids are internal record ids, so QB stays on the name.
  const { selectedPaidol } = useAppSelector(selectUserCompanies);
  const { agaveAccount } = useAppSelector(selectAgaveSlice);
  const showEmployeeId = supportsCodeSort(selectedPaidol, agaveAccount?.source_system?.slug);

  return (
    <CodingEntityDropdown<AgaveEmployeeEntity>
      entityType="employees"
      selectedItem={selectedEmployee}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder}
      identifierField={showEmployeeId ? 'source_id' : 'name'}
      enabled={enabled}
      locationId={locationId}
      fetchOnlyOnOpen={fetchOnlyOnOpen}
    />
  );
};

export default AgaveEmployeesDropdown;
